import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/dialogPlanSelectionPageModalQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
	offeringName: string;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-plan-selection-page-modal" */ './dialog'
			),
		{
			moduleId: 'edition-awareness-plan-selection-page-modal',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey, offeringName }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			tenantContexts: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
					offeringName,
				},
			},
		},
	}),
});
